import { useEffect, forwardRef, useRef, useState } from 'react';
import {
  TextField,
  TableRow,
  Grid,
  Button,
} from '@mui/material';
import { TableColumnCell } from 'src/components/TableColumnCell';

interface CreateTaskRowProps {
  onChange?: (e: any) => void,
  onClose?: () => void,
  onCreate?: (taskDescription: string) => void,
}

const CreateTaskRow = forwardRef((props: CreateTaskRowProps, _ref) => {
  const textFieldRef = useRef(null);
  const [taskDescription, setTaskDescription] = useState('');

  useEffect(() => {
    if (textFieldRef.current) {
      textFieldRef.current.focus();
    }
  }, [])

  const TextFieldStyle = {
    fontSize: '12px',
    width: '100%'
  };

  const handleClose = () => {
    setTaskDescription('');
    props?.onClose();
  }

  return (
    <TableRow hover>
      <TableColumnCell colSpan={8}>
        <Grid display='flex' alignItems='center' justifyContent='flex-start' gap={1}>
          <TextField
            inputRef={textFieldRef}
            className="input-text"
            size="small"
            variant="outlined"
            style={TextFieldStyle}
            inputProps={{
              max: 100,
              min: 0,
              style: {
                fontSize: '12px',
                padding: '5.5px 14px'
              }
            }}
            type="text"
            value={taskDescription}
            onChange={(e) => {
              setTaskDescription(e.target.value)
            }}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                if (taskDescription.length > 0) {
                  props?.onCreate(taskDescription)
                }
              }
            }}
          />
          <Button
            sx={{ mt: { xs: 2, md: 0 } }}
            id="btn-onSubmit"
            variant="outlined"
            style={{ height: '1.75rem', fontSize: '12px' }}
            disabled={taskDescription.length > 0 ? false : true}
            onClick={() => props?.onCreate(taskDescription)}
          >
            Create
          </Button>
          <Button
            sx={{ mt: { xs: 2, md: 0 } }}
            id="btn-onSubmit"
            className='close-btn'
            variant="outlined"
            style={{ height: '1.75rem', fontSize: '12px' }}
            onClick={() => handleClose()}
          >
            Close
          </Button>
        </Grid>
      </TableColumnCell>
    </TableRow>
  );
});

export default CreateTaskRow;
